import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-161">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-cream/95 backdrop-blur-sm border-t border-brown/10 z-50 md:hidden shadow-[0_-4px_20px_rgba(0,0,0,0.05)]" data-id="element-162">
          <CTAButton text="Get the Reset" price="$6.39" originalPrice="$19.97" discountLabel="68% OFF" fullWidth data-id="element-163" />
        </motion.div>}
    </AnimatePresence>;
}